"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { localizePath, type Locale } from "@/lib/i18n/config";

export function LangSwitcher({ current }: { current: Locale }) {
  const pathname = usePathname();
  const target: Locale = current === "da" ? "en" : "da";
  const targetPath = localizePath(pathname, target);

  return (
    <>
      {/* Mobile: top-venstre, halv-fast med header (matcher demo) */}
      <div
        className="fixed left-3 top-[72px] z-[91] flex bg-white/96 backdrop-blur-sm rounded-b-[10px] p-1 shadow-[0_6px_14px_rgba(0,23,37,.10)] lg:hidden"
        style={{ position: "fixed" }}
      >
        <Link
          href={targetPath}
          aria-label={target === "en" ? "Switch to English" : "Skift til dansk"}
          className="w-[34px] h-[24px] flex items-center justify-center rounded-[4px] overflow-hidden hover:scale-105 transition-transform"
        >
          {target === "en" ? <UkFlag /> : <DkFlag />}
        </Link>
        <span
          className="pointer-events-none absolute left-0 right-0 bottom-0 h-1/2 rounded-b-[10px] border border-t-0 border-[var(--color-line)]"
          aria-hidden="true"
        />
      </div>

      {/* Desktop: top-højre, fuld ramme — centreret lodret mellem header-bund (88px) og hero-card-top (~160px) */}
      <div className="hidden lg:flex fixed top-[108px] right-5 z-[91] bg-white/96 backdrop-blur-sm rounded-[10px] border border-[var(--color-line)] shadow-md p-[5px]">
        <Link
          href={targetPath}
          aria-label={target === "en" ? "Switch to English" : "Skift til dansk"}
          className="w-[36px] h-[26px] flex items-center justify-center rounded-[4px] overflow-hidden hover:scale-105 transition-transform"
        >
          {target === "en" ? <UkFlag /> : <DkFlag />}
        </Link>
      </div>
    </>
  );
}

function DkFlag() {
  return (
    <svg viewBox="0 0 37 28" className="w-full h-full block" aria-hidden="true">
      <rect width="37" height="28" fill="#C8102E" />
      <rect x="12" width="4" height="28" fill="#fff" />
      <rect y="12" width="37" height="4" fill="#fff" />
    </svg>
  );
}

function UkFlag() {
  return (
    <svg viewBox="0 0 60 30" className="w-full h-full block" aria-hidden="true">
      <rect width="60" height="30" fill="#012169" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" strokeWidth="2.5" />
      <rect x="25" width="10" height="30" fill="#fff" />
      <rect y="10" width="60" height="10" fill="#fff" />
      <rect x="27" width="6" height="30" fill="#C8102E" />
      <rect y="12" width="60" height="6" fill="#C8102E" />
    </svg>
  );
}
